import React from 'react';

import styled from '../../../styled';

const Ratio = ({ ratio = 56, children, contentWrapperClass = '', ...rest }) => {
  return (
    <Wrapper {...rest}>
      <RatioSpace ratio={ratio} />
      <Content className={contentWrapperClass}>{children}</Content>
    </Wrapper>
  );
};

export default Ratio;

const Content = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});
const RatioSpace = styled('div')(({ ratio }: { ratio: number }) => ({
  width: '100%',
  paddingTop: ratio + '%',
}));

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hideVideoIframe',
})({
  position: 'relative',
  width: '100%',
});
